<template>
  <div class="sign-list">
    <!-- shearch -->
    <el-row type="flex" class="row" justify="end">
      <el-col :span="8" style="margin-right: 10px">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-select v-model="selectedParm" placeholder="请选择" size="small">
              <el-option label="文件名称" value="contractName" />
              <!--<el-option label="文件编号" value="applyNo"/>-->
              <el-option label="签署方" value="signatoryFullName" />
              <!--<el-option label="手机号" value="signatoryMobile"/>-->
              <!--<el-option label="证件号" value="signatoryIdentityCard"/>-->
            </el-select>
          </el-col>
          <el-col :span="12">
            <el-input v-model="selectedParmInfo" size="small" placeholder="查询内容" />
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="4" v-if="+$route.query.signStatus !== 5">
        <div style="text-align: center; white-space: nowrap">
          <el-select style="width: 140px" v-model="selectedStatus" placeholder="请选择" size="small">
            <el-option
              v-for="(item, index) in statusEnum"
              :label="item.label"
              :key="'status' + index"
              :value="item.value"
            />
          </el-select>
        </div>
      </el-col>
      <el-col :span="5">
        <el-date-picker
          v-model="datePikerArr"
          type="daterange"
          value-format="yyyy-MM-dd"
          :default-time="['00:00:00', '23:59:59']"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="small"
          style="width: unset"
        />
      </el-col>
      <el-col :span="3" class="text-right">
        <el-row type="flex">
          <el-col :span="12">
            <el-button @click="findScreenSign" size="small">查询</el-button>
          </el-col>
          <el-col :span="12">
            <el-button @click="rest" size="small">重置</el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <!-- 数据展示 -->
    <el-table
      style="min-height: 54vh"
      :data="tableList"
      v-loading="loading"
      class="data-list"
      ref="dataList"
      tooltip-effect="dark"
      :key="'signlist-' + $route.query.signStatus"
      :expand-row-keys="expandKeys"
      :row-key="
        (row) => {
          return row.applyId;
        }
      "
      @cell-mouse-enter="cellMouseEnter"
      @cell-mouse-leave="cellMouseLeave"
      @selection-change="handleSelectionChange"
      :header-cell-style="{
        background: '#f9f9f9',
        color: '#333333',
        fontWeight: '500',
      }"
    >
      <el-table-column type="selection" width="55" />
      <!--      <el-table-column label="" width="70" show-overflow-tooltip>-->
      <!--        <template slot-scope="scope">-->
      <!--          <div class="my-icon-box">-->
      <!--            <el-tooltip-->
      <!--              class="item"-->
      <!--              effect="dark"-->
      <!--              :content="(scope.row.tag || [])[0].tagName"-->
      <!--              placement="top"-->
      <!--              v-if="(scope.row.tag || [])[0]"-->
      <!--            >-->
      <!--              <i-->
      <!--                class="iconfont icontag pointer"-->
      <!--                :style="{ color: (scope.row.tag || [])[0].tagColour }"-->
      <!--                @click="setTag(null, scope.row)"-->
      <!--              ></i>-->
      <!--            </el-tooltip>-->
      <!--            <el-popover-->
      <!--              v-show="scope.row.showTag"-->
      <!--              placement="top"-->
      <!--              width="200"-->
      <!--              trigger="hover"-->
      <!--            >-->
      <!--              <i class="iconfont icontag pointer" slot="reference"></i>-->
      <!--              <div class="hover-win">-->
      <!--                <el-tooltip-->
      <!--                  class="item"-->
      <!--                  effect="dark"-->
      <!--                  :content="tag.tagName"-->
      <!--                  placement="top"-->
      <!--                  v-for="(tag, index) in tagLists"-->
      <!--                  :key="'tag_a' + index"-->
      <!--                >-->
      <!--                  <i-->
      <!--                    class="iconfont icontag pointer margin-lr-5"-->
      <!--                    @click="setTag(tag, scope.row)"-->
      <!--                    :style="{ color: tag.tagColour }"-->
      <!--                  ></i>-->
      <!--                </el-tooltip>-->
      <!--                <i-->
      <!--                  class="iconfont iconbianji pointer margin-lr-5"-->
      <!--                  @click="showTagManage()"-->
      <!--                ></i>-->
      <!--              </div>-->
      <!--            </el-popover>-->
      <!--          </div>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <el-table-column label="文件名称" min-width="300">
        <template slot-scope="scope">
          <div
            style="
              display: flex;
              align-items: center;
              position: relative;
              padding-top: 10px;
            "
          >
            <span class="multiFile" v-if="scope.row.files > 1">多</span>
            <corp-apply-name
              applyType="signList"
              :signInfo="{
                fromDingTalk: scope.row.fromDingTalk || null,
                signStatus: scope.row.signStatus,
                selfSign: scope.row.selfSign,
                selfApprove: scope.row.selfApprove,
                signNo: scope.row.signNo,
                contractName: scope.row.contractName,
                applyNo: scope.row.applyNo,
                approveId: scope.row.approveId,
                multiFile: scope.row.multiFile,
                aiCorpUserIdFlag: scope.row.aiCorpUserIdFlag,
              }"
            />
          </div>
          <p class="textEllipsis">发起方：{{ scope.row.ebqUserName }}</p>
          <p class="textEllipsis">
            发起时间：{{ scope.row.createTime | formatDateHM }}
            <el-tooltip effect="dark" content="由钉钉发起的" placement="bottom-start">
              <img
                src="/images/icon/dingIcon.png"
                alt="钉钉"
                width="20px"
                v-if="scope.row.fromDingTalk && scope.row.fromDingTalk == 1 && !isInDingTalk"
              />
            </el-tooltip>
          </p>
        </template>
      </el-table-column>
      <!--      <el-table-column label="发起方" prop="ebqUserName" show-overflow-tooltip/>-->
      <!--      <el-table-column label="签署方" prop="allSignerName"/>-->
      <el-table-column label="签署方" min-width="250">
        <template slot-scope="scope">
          <el-tooltip placement="bottom-start">
            <div
              slot="content"
              v-for="(item, i) in scope.row.signInfoVOS"
              :key="i"
              style="display: flex; align-items: center; padding-bottom: 5px"
            >
              <span
                v-if="item.orderNum && item.orderNum >= 1"
                style="
                  display: block;
                  width: 13px;
                  height: 13px;
                  border-radius: 50%;
                  color: #ffffff;
                  border: 1px solid #ffffff;
                  text-align: center;
                  line-height: 13px;
                  font-size: 12px;
                "
              >{{ item.orderNum }}</span>
              <span v-else style="color: #ffffff">·</span>
              <div style="color: #ffffff; font-size: 12px">
                【{{
                item.signStatus === 0 || item.signStatus === -1
                ? "未签署"
                : item.signStatus === 1
                ? "已签署"
                : "已拒签"
                }}】
              </div>
              <p style="color: #ffffff; font-size: 12px">{{ item.signatoryFullName }}</p>
            </div>
            <div>
              <p class="textEllipsis">{{ scope.row.signInfoVOS[0].signatoryFullName }}</p>
              <p
                class="textEllipsis"
                v-if="scope.row.signInfoVOS.length > 1"
              >{{ scope.row.signInfoVOS[1].signatoryFullName }}</p>
              <template>
                <p
                  class="textEllipsis"
                  v-if="(scope.row.signInfoVOS.length === 3)"
                >{{ scope.row.signInfoVOS[2].signatoryFullName }}</p>
                <p class="textEllipsis" v-if="(scope.row.signInfoVOS.length > 3)">···</p>
              </template>
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="100" show-overflow-tooltip>
        <template slot-scope="scope">
          <template v-if="scope.row.signStatus === -3">
            <span v-if="scope.row.selfApprove === 1" class="red">待我审</span>
            <span v-else class="blue">待ta审</span>
          </template>
          <template v-else-if="scope.row.signStatus === -4" class="orange">
            <p>审批驳回</p>
          </template>
          <template v-else-if="scope.row.signStatus === 0">
            <p v-if="scope.row.selfSign === 1" class="red">待我签</p>
            <p v-else class="blue">待ta签</p>
          </template>
          <template v-else-if="scope.row.signStatus === 1">
            <span class="green">已完成</span>
          </template>
          <template v-else-if="scope.row.signStatus === 2">
            <span class="orange">已拒签</span>
          </template>
          <template v-else-if="scope.row.signStatus === -5">
            <span class="grey">已撤销</span>
          </template>
          <template v-else-if="scope.row.signStatus === -6">
            <span class="grey">已过期</span>
          </template>
        </template>
      </el-table-column>
      <!-- <el-table-column type="expand" width="1">
        <template slot-scope="scope">
          <el-form inline class="demo-table-expand">
            <el-form-item>
              <more-button
                :rowData="scope.row"
                :showMoreBtn="true"
                @btnMethodFn="openLYDialog"
              ></more-button>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>-->
      <el-table-column label="操作" width="130px">
        <template slot-scope="scope" v-if="!(scope.row.applyNo && scope.row.applyNo.startsWith('APLO'))">
          <div class="operate-box pointer">
            <corp-handles
              v-if="scope.row.signStatus !== 1"
              ref="handlesComp"
              :rowData="scope.row"
              applyType="signList"
              @setCSDialogData="onSetCSDialogData"
              @setSSDialogData="onSetSSDialogData"
              @resetList="getSignLists"
            ></corp-handles>
            <!--            <span-->
            <!--              v-if="scope.row.vpresId"-->
            <!--              @click="onGetCerti(scope.row)"-->
            <!--              class="com-normal-btn"-->
            <!--            >证书</span-->
            <!--            >-->
            <template v-if="scope.row.signStatus === 1">
              <!--            <div-->
              <!--              v-if="scope.row.signStatus === 1"-->
              <!--              @click="openLYDialog(scope.row)"-->
              <!--              class="com-normal-btn"-->
              <!--            >-->
              <!--              上传履约文件-->
              <!--            </div>-->
              <!--              <span-->
              <!--                v-if="scope.row.vpresId"-->
              <!--                id="tag-copy"-->
              <!--                :data-clipboard-text="scope.row.vpresId"-->
              <!--                @click="copyTextToQuery(scope.row.vpresId)"-->
              <!--                class="com-normal-btn"-->
              <!--              >-->
              <!--                存证查询-->
              <!--              </span>-->
              <existing-evidence :rowData="scope.row" @copyTextToQueryEmit="copyTextToQuery"></existing-evidence>
              <!-- <div
                class="com-normal-btn"
                @click="moreBtnShowFn(scope.row)"
              >
                更多操作
              </div>-->

              <el-dropdown trigger="click" @visible-change="visiChange($event, scope.row.applyId)">
                <span class="com-normal-btn">
                  更多操作
                  <i
                    :class="
                      visiDown.status &&
                      visiDown.rowApplyId == scope.row.applyId
                        ? 'el-icon-caret-top'
                        : 'el-icon-caret-bottom'
                    "
                    class="com-normal-btn el-icon--right"
                  ></i>
                </span>
                <el-dropdown-menu slot="dropdown" style="background-color: #f5f6f6">
                  <more-button :rowData="scope.row" :showMoreBtn="true" @btnMethodFn="openLYDialog"></more-button>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </div>
        </template>
      </el-table-column>
      <no-data text="暂无数据" slot="empty" />
    </el-table>
    <!--    <div-->
    <!--      class="bulkOperation"-->
    <!--      v-if="-->
    <!--        batchLength &&-->
    <!--        (!$route.query.signStatus || $route.query.signStatus !== 2)-->
    <!--      "-->
    <!--    >-->
    <!--      已选{{ batchLength }}份文件-->
    <!--    </div>-->
    <!--分页栏-->
    <el-row class="pageation row" :style="{ marginLeft: !$route.query.signStatus ? '70px' : 0 }">
      <el-col :span="8">
        <el-button
          v-if="![4, 5].includes(+$route.query.signStatus)"
          @click="batchDown"
          size="small"
        >下载</el-button>
        <!--        <el-button-->
        <!--          @click="deleteFileFn"-->
        <!--          size="small"-->
        <!--        >删除</el-button-->
        <!--        >-->
        <el-button @click="emitFn('saveToDir')" size="small">归档</el-button>
        <!--  抄送按钮，除开抄送列表      -->
        <el-button v-if="!$route.query.ccToMe && false" @click="selectCcUserFn()" size="small">抄送</el-button>
        <!-- 批量签署 -->
        <el-tooltip effect="dark" v-if="$route.query.signStatus == 4 && false">
          <p slot="content" style="width: 200px; line-height: 1.5">
            批量签署规则：
            <br />1、当前签署方必须有固定签章位置
            <br />2、当前签署方不需要进行身份认证
            <br />3、当前签署方不包含强制阅读、强制现场
            <br />4、待ta签的合同不能进行批量签署
          </p>
          <el-button @click="batchSign" size="small">批量签署</el-button>
        </el-tooltip>
      </el-col>
      <el-col :span="16" class="page-flex-end">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="screenParme.itemPage"
          :pager-count="5"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="screenParme.pageSize"
          layout="sizes, prev, pager, next, total"
          :total="screenParme.pageTotal"
        />
        <el-go
          :page-size="screenParme.pageSize"
          :total="screenParme.pageTotal"
          @current-change="handleCurrentChange"
        ></el-go>
      </el-col>
    </el-row>
    <!--标签管理-->
    <tag-manage @close="getTagList" @refresh="getSignLists" :isCrop="true" ref="tagManage" />
    <certiServiceDialog
      v-if="cSDialogVisible"
      :dialogVisible="cSDialogVisible"
      listType="corpList"
      :param="cSDialogData"
      @setCSDialogData="onSetCSDialogData"
    ></certiServiceDialog>

    <selectSubjectDialog
      v-if="sSDialogVisible"
      :dialogVisible="sSDialogVisible"
      :param="sSDialogData"
      @setSSDialogData="onSetSSDialogData"
    ></selectSubjectDialog>

    <!--履约文件-->
    <el-dialog title="履约文件" :visible.sync="lYDialogVisible" width="850px" class="ly-info">
      <el-tabs v-model="activeName" class="ly-mask" @tab-click="handleClick">
        <el-tab-pane label="上传原文件" name="1">
          <p class="tips">支持常见图片、文档、视频、音频、压缩包格式，上传后会保存原文件，单个文件大小不超过30MB</p>
          <div class="box-wrap">
            <div class="temone add">
              <span class="el-icon-plus"></span>
              <input ref="referenceUpload" type="file" class="file-ipt" @change="handleInputChange" />
            </div>

            <div class="temone" v-for="(item, idx) in lYDialogData" :key="idx">
              <div class="t-box">
                <img class="y-img" src="/images/web/file-icon.png" />
                <div class="msk">
                  <span class="des">上传人：{{ item.userName }} -{{ item.accountName }}</span>
                </div>
              </div>

              <div class="a-btn">
                <a class="has-hover" :href="downloadLYFile(item.file)">下载</a>
                <a v-if="isDoc(item)" class="has-hover" @click="previewDoc(item)">预览</a>
                <a v-if="isVideoOrImg(item)" class="has-hover" @click="previewVideOrImg(item)">预览</a>
                <a v-if="item.canDelete" class="has-hover" @click="delLYFile(item)">删除</a>
                <a class="no-hover">{{ item.fileName }}</a>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="上传文件哈希" name="2">
          <p class="tips">格式没有限制，仅保存上传文件的特征值（哈希），不对文件本身做保存，单个文件大小不超过500M</p>

          <div class="box-wrap">
            <div class="temone add">
              <span class="el-icon-plus"></span>
              <input
                ref="referenceUpload1"
                type="file"
                class="file-ipt"
                @change="handleInputChange"
              />
            </div>

            <div class="temone" v-for="(item, idx) in lYDialogData" :key="idx">
              <div class="t-box">
                <img class="y-img" src="/images/web/hash-icon.png" />
                <div class="msk">
                  <span class="des">上传人：{{ item.userName }} -{{ item.accountName }}</span>
                  <br />
                  <span class="des" style="margin: 0">备案号：{{ item.presId }}</span>
                </div>
              </div>

              <div class="a-btn">
                <a class="has-hover" @click="validLYFile(item)">验证</a>
                <a v-if="item.canDelete" class="has-hover" @click="delLYFile(item)">删除</a>
                <a class="no-hover">{{ item.fileName }}</a>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="footer">
        <span class="num">
          文件数：
          <label>{{ lYDialogData.length }}</label>个
        </span>
        <el-button
          type="primary"
          size="small"
          class="cancel-btn"
          @click="lYDialogVisible = false"
        >关闭</el-button>
      </div>
    </el-dialog>

    <!--pdf文件预览-->
    <ViewFilesToDoc
      :visibleShow="visibleShowEnclosureDoc"
      :enclosurePreviewNumItem="enclosurePreviewNumItem"
      @setViewFilesToDocDialogData="onSetViewFilesToDocDialogData"
    />
    <!--附件图片video预览显示-->
    <ViewFilesToImg
      :visibleShow="visibleShowEnclosure"
      :isRefresh="isRefresh"
      :enclosurePreviewNumItem="enclosurePreviewNumItem"
      :imgList="getEnclosureImgList"
      @setViewFilesToImgDialogData="onSetViewFilesToImgDialogData"
      style="text-align: center"
    />
    <!--  提示展示批量签署时提醒签章   -->
    <el-dialog
      :visible.sync="nodeQueryVisible"
      width="800px"
      custom-class="data-dialog"
      destroy-on-close
    >
      <div class="node_header" slot="title">保全链节点查询</div>
      <p style="padding: 10px">当前合同备案号：{{ vpresId }}</p>
      <node-query :vpresId="vpresId" />
    </el-dialog>
    <!--  选择抄送人  -->
    <selectCcUser ref="selectCcUserRef" @clearListFn="clearListFn" :applyNosArr="applyNosArr" />
    <!--  提示展示批量签署时提醒签章   -->
    <el-dialog title="系统提示" :visible.sync="multiBatchDialogVisible" width="30%">
      <div class="batch-tips">
        <p>
          <i class="el-icon-info" style="margin-right: 10px; font-size: 20px"></i>
          确定使用以下印章，对 “{{ batchContractName }}” 等
          {{ signInfoIdsLength }}
          份文件中所有签章位置进行盖章（文件需要手写签字请勿使用此功能）？
        </p>
        <p>若印章使用时需要进行用印审批，不支持批量签署。</p>
        <!-- <div class="temone" v-if="chapterList.lengt !== 0">
          <div class="t-box">
            <div class="chap-list-box">
              <template v-for="(chap, i) of chapterList">
                <img
                  :key="i"
                  :src="chap.signUrl"
                  :class="{
                    'active-chap':
                      checkChapter &&
                      checkChapter.corpSealId === chap.corpSealId,
                  }"
                  @click="checkUseChap(chap)"
                />
              </template>
            </div>
          </div>
        </div>-->
        <div class="temone-box">
          <div class="temone" style="margin: 10px" v-for="(item, i) of chapterList" :key="i">
            <div
              class="t-box"
              :class="{
                'active-chap':
                  checkChapter && checkChapter.corpSealId === item.corpSealId,
              }"
              @click="checkUseChap(item)"
            >
              <template v-if="item.hasOwnProperty('signUrl')">
                <img class="y-img" :src="item.signUrl" />
              </template>
              <!-- <template v-else>
                <img
                  class="y-img"
                  :src="'data:image/jpeg;base64,' + item.signName"
                />
              </template>-->
            </div>
            <p>
              {{
              item.hasOwnProperty("signUrl")
              ? `${item.sealName}(ID:${item.corpSealId})`
              : "系统图形章"
              }}
            </p>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <a href="/tpl/personSet" style="float: left">去更换默认章>></a> -->
        <el-button
          style="color: #1b1b1b; background: #fff"
          size="small"
          @click="multiBatchDialogVisible = false"
        >取 消</el-button>
        <el-button size="small" type="primary" @click="batchSignAll">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Bus from "@/plugins/bus.js";
import existingEvidence from "@/components/apply-list/existing-evidence";
import certiServicepopover from "@/components/apply-list/certiServicepopover";
import nodeQuery from "@/components/signInfo/node-query";
import moreButton from "@/components/apply-list/more-button";
import selectCcUser from "@/components/selectCcUser/index";
import {
  delSignBySignNos,
  ApiMethods,
  configUrl,
  getFindFileDownload
} from "@/assets/js/http-serve/http-methods";
import {
  postSignPage,
  postSignBadge,
  ApiCorpMethods,
} from "@/assets/js/http-serve/corp/http-methods";
import { fileOperShow } from "@/assets/js/http-serve/http-methods";

import ElGo from "@/components/go/Go";
import CorpHandles from "@/components/apply-list/corpHandles";
import CorpApplyName from "@/components/apply-list/corpContractName";
import TagManage from "@/components/tag-manage";
import CertiServiceDialog from "@/components/apply-list/certiServiceDialog";
import SelectSubjectDialog from "@/components/apply-list/selectSubjectDialog";
import ViewFilesToDoc from "@/components/viewFiles/ViewFilesToDoc";
import ViewFilesToImg from "@/components/viewFiles/ViewFilesToImg";
import sha512Crypto from "js-sha512";
import EntSignController from "@/assets/js/http-serve/entSignController";
import Clipboard from "clipboard";
import { isInDingTalk } from "@/assets/js/utils/ding-env";

export default {
  name: "signList",
  components: {
    existingEvidence,
    certiServicepopover,
    nodeQuery,
    moreButton,
    ElGo,
    CorpHandles,
    CorpApplyName,
    TagManage,
    CertiServiceDialog,
    SelectSubjectDialog,
    ViewFilesToDoc,
    ViewFilesToImg,
    selectCcUser
  },
  data () {
    return {
      // 批量删除收到的签署
      signNos: "",
      signNoList: [],
      batchApplyNos: "",
      batchContractName: "",
      isInDingTalk,
      //  新增批量签署时提示默认章
      multiBatchDialogVisible: false,
      defaultChapter: null,
      chapterList: [],
      checkChapter: null,
      visiDown: { status: false, rowApplyId: "" },
      nodeQueryVisible: false,
      vpresId: "",
      expandKeys: [], //展开行
      getDTag: false,
      cSDialogVisible: false, //证书弹出框显示
      cSDialogData: {}, //证书弹出框数据
      sSDialogVisible: false, // 请选择出证主体身份弹出框显示
      sSDialogData: {}, //请选择出证主体身份数据
      tagLists: [],
      // 签署列表
      tableList: [],
      // 筛选
      screenParme: {
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0,
        dateType: null,
        beginDate: null,
        endDate: null,
        applyNo: null,
        signNo: null,
        contractName: null,
        signatoryFullName: null,
        signatoryMobile: null,
        signatoryIdentityCard: null,
        signStatusSet: null,
        searchType: null,
        ebqUserName: null
      },
      selectedParm: "contractName",
      selectedParmInfo: "",
      selectedStatus: "",
      datePikerArr: null,
      // 批量删除收到的签署
      badge: 0,
      signStatusSet: null,
      directoryId: null,
      signStatus: null,
      loading: false,
      batchLength: null,
      //履约文件数据
      lYDialogVisible: false, //履约文件弹窗
      lYDialogData: [], //履约文件列表
      activeName: "1", //1：文件上传，2：hash值上传
      visibleShowEnclosure: false,
      visibleShowEnclosureDoc: false,
      enclosurePreviewNumItem: {}, // 当前预览项
      isRefresh: true, // 预览附件时，强制刷新
      rowData: {},
      //  抄送applyNosArr
      applyNosArr: []
    };
  },
  inject: ["reload"],
  mounted () {
    let query = this.$route.query;
    //定制默认
    this.signStatus = 1;
    //----------
    this.directoryId = query ? query.directoryId : null;
    this.signStatusFn(this.signStatus);
    this.getTagList();
    //清除归档操作后的缓存
    Bus.$on('$saveToDirNewEndClear', () => {
      this.$refs["dataList"].clearSelection();
      this.getSignLists();
    })
  },
  destroyed () {
    this.batchLength = null;
    this.$emit("batchLength", this.batchLength);
    Bus.$off("$saveToDirNewEndClear");
  },
  computed: {
    signInfoIdsLength () {
      return this.signNoList.length;
    },
    statusEnum () {
      if (this.$route.query.signStatus == "2") {
        // 未完成
        return [
          {
            label: "全部",
            value: "-1"
          },
          {
            label: "待我审",
            value: "6"
          },
          {
            label: "待ta审",
            value: "7"
          },
          {
            label: "待我签",
            value: "0"
          },
          {
            label: "待ta签",
            value: "1"
          }
        ];
      } else if (this.$route.query.signStatus == "3") {
        // 已结束
        return [
          {
            label: "全部",
            value: "-1"
          },
          {
            label: "已完成",
            value: "2"
          },
          {
            label: "已拒签",
            value: "3"
          },
          {
            label: "已过期",
            value: "4"
          },
          {
            label: "已撤销",
            value: "5"
          },
          {
            label: "审批驳回",
            value: "8"
          }
        ];
      } else if (this.$route.query.signStatus == "4") {
        // 待签的
        return [
          {
            label: "全部",
            value: "-1"
          },
          {
            label: "待我签",
            value: "0"
          },
          {
            label: "待ta签",
            value: "1"
          }
        ];
      } else if (this.$route.query.signStatus == "5") {
        // 待审批
        return [
          {
            label: "全部",
            value: "-1"
          },
          {
            label: "待我审",
            value: "6"
          },
          {
            label: "待ta审",
            value: "7"
          }
        ];
      } else {
        return [
          {
            label: "全部",
            value: "-1"
          },
          {
            label: "待我审",
            value: "6"
          },
          {
            label: "待ta审",
            value: "7"
          },
          {
            label: "待我签",
            value: "0"
          },
          {
            label: "待ta签",
            value: "1"
          },
          {
            label: "已完成",
            value: "2"
          },
          {
            label: "已拒签",
            value: "3"
          },
          {
            label: "已过期",
            value: "4"
          },
          {
            label: "已撤销",
            value: "5"
          },
          {
            label: "审批驳回",
            value: "8"
          }
        ];
      }
    },
    // 获取附件中的图片列表，用于预览
    getEnclosureImgList () {
      let a = this.lYDialogData.filter(item => {
        return this.isVideoOrImg(item);
      });
      return a;
    }
  },
  watch: {
    datePikerArr: {
      handler (val) {
        if (val && val.length === 2) {
          this.screenParme.beginDate = val[0];
          this.screenParme.endDate = val[1];
        } else {
          this.screenParme.beginDate = this.screenParme.endDate = null;
        }
      },
      deep: true
    },
    selectedParm: function (newVal, oldVal) {
      this.screenParme[newVal] = this.screenParme[oldVal];
      this.screenParme[oldVal] = null;
    },
    selectedParmInfo: function (val) {
      this.screenParme[this.selectedParm] = val;
    },
    selectedStatus: function (val) {
      this.screenParme["selfSign"] = null;
      this.screenParme["selfApprove"] = null;
      this.screenParme["signStatusSet"] = this.signStatusSet;
      switch (val) {
        case "-1":
          this.addConditionFn();//追加判断
          break;
        case "0":
          this.screenParme["signStatusSet"] = "0";
          this.screenParme["selfSign"] = 1;
          break;
        case "1":
          this.screenParme["signStatusSet"] = "0";
          this.screenParme["selfSign"] = 0;
          break;
        case "2":
          this.screenParme["signStatusSet"] = "1";
          break;
        case "3":
          this.screenParme["signStatusSet"] = "2";
          break;
        case "4":
          this.screenParme["signStatusSet"] = "-6";
          break;
        case "5":
          this.screenParme["signStatusSet"] = "-5";
          break;
        case "6":
          this.screenParme["signStatusSet"] = "-3";
          this.screenParme["selfApprove"] = 1;
          break;
        case "7":
          this.screenParme["signStatusSet"] = "-3";
          this.screenParme["selfApprove"] = 0;
          break;
        case "8":
          this.screenParme["signStatusSet"] = "-4";
          break;
      }
    },

    directoryId (val) {
      // this.screenParme["directoryId"] = val;
      // this.getSignLists();
    },
    $route: {
      handler () {
        this.resetScreenParams();
        let query = this.$route.query;
        this.signStatus = 1;
        this.directoryId = query ? query.directoryId : null;
        this.screenParme["directoryId"] = this.directoryId;
        this.signStatusFn(this.signStatus); //NO1
      },
      deep: true
    }
  },
  methods: {
    /** 选择签章用于批量签署 */
    checkUseChap (chap) {
      this.checkChapter = chap
    },
    /** 批量签署 */
    batchSignAll () {
      if (!this.checkChapter) return this.$message.error('请选择要使用的签章')
      if (this.checkChapter.flowId) return this.$message.error(' 当前印章需要进行用印审批，不符合批量签署规则，请重新选择')
      this.multiBatchDialogVisible = false;
      this.loading = true;
      const signNos = this.signNoList.map(i => i.signNo);
      ApiCorpMethods.SealController.batchSign({
        signNos: signNos.toString(),
        corpSealId: this.checkChapter.corpSealId
      })
        .then(res => {
          if (!res.success) {
            if (!((res.data || {}).noPassContract || [])[0])
              return this.$message.error(res.description || this.$tip);
            return this.$confirm(
              `"${(res.data || {}).noPassContract[0].contractName}"等${(res.data || {}).noPassContract.length
              }
                份合同不符合批量签署规则，请重新选择`,
              "系统提示",
              {
                showCancelButton: true,
                type: "info"
              }
            ).then(() => { });
          }
          this.$message.success("批量签署成功");
          this.getSignLists();
        })
        .finally(() => (this.loading = false));
    },
    async batchSign () {
      const signOthers = this.signNoList.filter(item => {
        return item.selfSign !== 1 || item.signStatus !== 0
      })
      if (signOthers.length > 0) {
        const text = `【${signOthers[0].contractName}】等${signOthers.length} 份已勾选合同不是【待我签】或不是【待签流程】`
        return this.$confirm(text, "系统提示", {
          showConfirmButton: true,
          showCancelButton: false
        })
      }
      if (this.signNoList.length === 0)
        return this.$confirm("请先勾选签署信息。", "系统提示", {
          showConfirmButton: true,
          showCancelButton: false
        });
      const signNos = this.signNoList.map(i => i.signNo);
      const ruleRes = await ApiCorpMethods.SealController.batchSignRule({
        signNos: signNos.toString(),
      })
      if (!ruleRes.success) {
        if (!((ruleRes.data || {}).noPassContract || [])[0])
          return this.$message.error(ruleRes.description || this.$tip);
        return this.$confirm(
          `"${(ruleRes.data || {}).noPassContract[0].contractName}"等${(ruleRes.data || {}).noPassContract.length
          }
                份合同不符合批量签署规则，请重新选择`,
          "系统提示",
          {
            showConfirmButton: true,
            showCancelButton: false,
            type: "info"
          }
        ).then(() => { });
      }
      const res = await ApiCorpMethods.SealController.listSeals()
      if (res.success) {
        if (res.data) {
          let list = res.data || null;
          if (list.length === 0) return this.$message.warning('未查询到您获得授权的签章，请获得授权后操作');

          // list.shift();
          list.forEach(t => {
            t.signUrl = fileOperShow(t.sealFile);
          });
          this.chapterList = list;
        } else {
          this.chapterList = [];
        }
      }
      this.multiBatchDialogVisible = true;
    },
    // 获取章列表933 需求获取默认章
    getChapterList () {
      EntSignController.getAllPreSeal()
        .then(data => {
          if (data.data.length > 1) {
            let _c = data.data.find(v => v.defaultChapter === 1);
            _c.signUrl = fileOperShow(_c.signUrl);
            this.defaultChapter = _c;
          } else {
            this.defaultChapter = data.data[0];
          }
        })
        .catch(err => console.log(err));
    },
    //三NO3
    signStatusSetFn (val) {
      this.selectedParm = "contractName";
      this.selectedParmInfo = "";
      this.datePikerArr = null;
      this.computeQueryParam(val);
      this.getSignLists();
    },
    //二NO2
    signStatusFn (val) {
      // NOTINIT(-1,"后台处理中..."), //挂起合同的原因可能是在处理其它事情（如在下载证书或其它事情）
      //   INPROGRESS(0, "待签"),
      //   COMPLETED(1, "完成"),
      //   REFUSE(2, "拒签"),
      //   PRES(3, "已保全"),
      //   DRAFT(-2,"草稿"),
      //   WAIT_APPROVA(-3,"待审批"),
      //   REFAULT_APPROVA(-4,"审批驳回"),
      //   CANCLE(-5,"已撤消"),
      //   EXIPRE(-6,"已失效"),//已撤消，已失效，审批驳回
      //   WAIT_BATCH_PROGRESS(-7,"等待后台批量处理");
      switch (val) {
        case 1:
          this.signStatusSet = "";
          break;
        case 2: // 未完成
          this.signStatusSet = "0,-3,-1";
          break;
        case 3: // 已结束
          this.signStatusSet = "1,2,-4,-5,-6";
          break;
        case 4: // 待签的
          this.signStatusSet = "0,-1";
          break;
        case 5: // 待审批
          this.signStatusSet = "-3";
          break;
        default:
          this.signStatusSet = "";
          break;
      }
      this.signStatusSetFn(this.signStatusSet);
    },
    visiChange (val, rowApplyId) {
      this.visiDown = {
        status: val,
        rowApplyId
      };
    },
    //选择抄送
    selectCcUserFn () {
      let arr = this.$refs["dataList"].selection;
      if (!arr.length) {
        return this.$message.error("请先选择文件");
      } else {
        this.applyNosArr = arr.map(item => {
          return item.applyNo;
        });
        this.$refs.selectCcUserRef.show();
      }
    },
    clearListFn () {
      this.$refs["dataList"].clearSelection();
    },
    // 复制并查询
    copyTextToQuery (vpresId) {
      this.vpresId = vpresId;
      this.nodeQueryVisible = true;
    },
    //更多按钮展开
    moreBtnShowFn (obj) {
      if (this.expandKeys[0] === obj.applyId) {
        this.expandKeys = [];
      } else {
        this.expandKeys = [obj.applyId];
      }
    },
    handleSelectionChange (val) {
      console.log('val====', val);
      // 这里是原逻辑
      // this.batchLength = val.length;
      // this.$emit("batchLength", this.batchLength);
      // this.batchApplyNos = "";
      // if (!val || !val.length) return;
      // this.batchApplyNos = (val || []).map(i => i.applyNo).join(",");
      // 这里是复制的
      this.batchLength = val.length;
      this.$emit("batchLength", this.batchLength);
      this.signNos = "";
      this.batchContractName = "";
      this.signNoList = [];
      this.batchApplyNos = "";
      if (!val || !val.length) return;
      let signNosArr = [];

      val.forEach(t => {
        signNosArr.push(t.signInfoNo);
      });
      this.signNoList = val;
      this.batchApplyNos = (val || []).map(i => i.applyNo).join(",");
      this.signNos = signNosArr.join(",");
      this.batchContractName = val[0].contractName;
    },
    //归档
    emitFn (fn) {
      let selection = this.$refs["dataList"].selection || [];
      if (!selection.length) return this.$message.warning('请选择要归档的文件')
      //触发signInfo中的归档操作
      Bus.$emit("$saveToDirNew", {
        selection: selection,
      })
    },
    //删除
    deleteFileFn () {
      let selection = [];
      try {
        selection = this.$refs["dataList"].selection;
      } catch (e) {
        this.$message.error("无法获取选中的文件，请刷新重试");
        console.log(e);
      }
      if (selection.length === 0) {
        return this.$confirm("请选择要删除的文件。", "系统提示", {
          showConfirmButton: true,
          showCancelButton: false
        });
      }
      this.$confirm("该操作删除后的合同将无法恢复，确认删除？", "系统提示", {
        confirmButtonText: "是",
        cancelButtonText: "否",
        type: "warning",
        dangerouslyUseHTMLString: true
      })
        .then(async () => {
          let applySet = [];
          selection.forEach(apply => {
            applySet.push(apply.applyId);
          });
          let res = await ApiCorpMethods.DirectoryController.draftDel({
            applyIds: applySet.join(",")
          });
          if (res.success) {
            this.$message.success(res.description || "移除文件成功");
            this.getSignLists();
          } else {
            this.$message.error(res.description || "移除文件失败");
          }
        })
        .catch(() => { });
    },
    batchDown () {
      if (!this.batchApplyNos)
        return this.$confirm("请先选择需要下载的签署。", "系统提示", {
          showConfirmButton: true,
          showCancelButton: false
        });
      ApiCorpMethods.CorpApplyContractController.downloadBatch({
        applyNos: this.batchApplyNos
      })
        .then(res => {
          if (!res.success)
            return this.$message.error(res.description || this.$tip);
          this.downloadFile(res.data);
        })
        .finally(() => (this.loading = false));
    },
    async downloadFile (param) {
      param.fix = ".zip";
      let res = await ApiMethods.FileOperController.download_get(param);
      if (res.success && res.url) {
        window.location.href = res.url;
      } else {
        this.$message.error(res.err);
      }
    },
    getTagList () {
      ApiMethods.CorpUserTagController.getAllUserTagList().then(res => {
        if (!res.success)
          return this.$message.error(res.description || this.$tip);
        if ((res.data || []).length === 0 && !this.getDTag)
          return this.getDefaultTag();
        this.tagLists = res.data;
      });
    },
    getDefaultTag () {
      this.getDTag = true;
      ApiMethods.CorpUserTagController.getDefaultTag().then(res => {
        if (!res.success)
          return this.$message.error(res.description || this.$tip);
        this.getTagList();
      });
    },
    setTag (tag, row) {
      this.$refs.tagManage.setTag(tag, row, 1).then(res => {
        if (!res.success)
          return this.$message.error(res.description || "操作失败");
        this.$set(row, "tag", []);
        tag && row.tag.push(tag);
      });
    },
    cellMouseEnter (row) {
      this.$set(row, "showTag", true);
    },
    cellMouseLeave (row) {
      row.showTag = false;
    },
    showTagManage () {
      this.$refs.tagManage.setVisible(true);
    },
    resetScreenParams () {
      this.selectedParm = "contractName";
      this.selectedParmInfo = "";
      this.selectedStatus = "";
      this.screenParme = {
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0,
        dateType: null,
        beginDate: null,
        endDate: null,
        applyNo: null,
        signNo: null,
        contractName: null,
        signatoryFullName: null,
        signatoryMobile: null,
        signatoryIdentityCard: null,
        signStatusSet: null,
        searchType: null,
        ebqUserName: null
      };
      this.datePikerArr = null;
      this.signStatus = this.$route.query ? this.$route.query.signStatus : null;
      this.directoryId = null;
    },
    /**
     * @param value value
     * @param space space
     */
    transferFormat (value, space) {
      if (typeof space !== "number") {
        return value;
      }
      if (value.length < space) return value;
      let v = "";
      for (let index = 0; index < value.length; index++) {
        if (index > 0 && index % space === 0) {
          v += "<br/>";
        }
        v += value[index];
      }
      return v;
    },
    computeQueryParam (signStatusSet) {
      this.screenParme = {
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0,
        dateType: null,
        beginDate: null,
        endDate: null,
        applyNo: null,
        signNo: null,
        contractName: null,
        signatoryFullName: null,
        signatoryMobile: null,
        signatoryIdentityCard: null,
        signStatusSet: signStatusSet,
        searchType: null
      };
      this.addConditionFn();//追加判断
      console.log("signStatusSet", signStatusSet);
    },
    //
    addConditionFn () {
      if (+this.$route.query.signStatus === 4) {
        this.screenParme["signStatusSet"] = "0";
      } else if (+this.$route.query.signStatus === 3) {
        this.screenParme["signStatusSet"] = "1,2,4,-5,-6,-4";
      } else if (+this.$route.query.signStatus === 5) {
        this.screenParme["signStatusSet"] = "-3";
        this.screenParme["createType"] = "1";
      }
    },
    // 重置
    rest () {
      this.resetScreenParams();
      // this.findScreenSign();
      this.signStatusFn(+this.signStatus);
    },
    // 查找筛选
    findScreenSign: function (screen) {
      if (screen) {
        this.screenParme.itemPage = screen.itemPage;
        this.screenParme.pageSize = screen.pageSize;
      } else {
        this.screenParme.itemPage = 1;
        this.screenParme.pageSize = 10;
      }
      this.getSignLists();
    },
    // 获取签署列表
    getSignLists () {
      this.loading = true;
      this.batchLength = null;
      this.$emit("batchLength", this.batchLength);
      this.screenParme.currentDirData = null;
      (this.$route.query.match == "-1" || this.$route.query.directoryId) &&
        (this.screenParme.currentDirData = 1);
      console.log(this.screenParme, '***-----')
      let newPar = {
        ...this.screenParme
      };
      if (this.$route.query.ccToMe || true) {
        newPar.onlyShowCC = 1;
        newPar.newVersion = 1;
      }
      if (["3", "4"].includes(this.$route.query.signStatus)) {
        newPar.newVersion = 1;
      }
      postSignPage(newPar)
        .then(data => {
          this.screenParme.pageSize = data.pageSize;
          this.screenParme.itemPage = data.pageNum;
          this.screenParme.pageTotal = data.total;
          this.tableList = data.data;
          // if (window.location.href.indexOf("match") > -1) {
          //   this.getSignBadge();
          // } else {
          this.badge = data.total;
          this.$emit("update:badge", data.total);
          // }
        })
        .catch(e => {
          console.log(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getSignBadge () {
      postSignBadge(this.screenParme).then(data => {
        this.badge = data.data;
        this.$emit("update:badge", data.data);
      });
    },
    // 分页
    handleSizeChange (val) {
      this.screenParme.itemPage = 1;
      this.screenParme.pageSize = val;
      this.getSignLists();
    },
    handleCurrentChange (val) {
      this.screenParme.itemPage = val;
      this.getSignLists();
    },
    async onGetCerti (data) {
      let _this = this;
      let _param;
      let viewUrlParam = {
        signNo: data.signNo || "",
        applyNo: data.applyNo || ""
      };
      let viewUrlRes = await ApiCorpMethods.ContractController.corpViewUrl(
        viewUrlParam
      );
      if (!viewUrlRes.success) {
        return _this.$message.error(viewUrlRes.description || "初始化数据失败");
      }
      _param = viewUrlRes.data;
      let certiRes = await ApiMethods.ApplySignController.certi(_param);
      if (certiRes.success) {
        _this.openCSDialog(certiRes.data);
      } else {
        let certiListRes = await ApiMethods.ApplySignController.certiList(
          _param
        );
        if (certiListRes.success) {
          if (!certiListRes.data || certiListRes.data.lengt == 0)
            return _this.$message.error("初始化数据失败");
          if (certiListRes.data.length === 1)
            return _this.openCSDialog(certiListRes.data[0]);
          if (certiListRes.data.length > 1)
            return _this.openSSDialog(certiListRes.data);
        } else {
          _this.$message.error(certiListRes.description);
        }
      }
    },
    openCSDialog (data) {
      this.cSDialogVisible = true;
      this.cSDialogData = data;
    },
    openSSDialog (data) {
      this.sSDialogVisible = true;
      this.sSDialogData = data;
      if (data.sSDialogData && !data.sSDialogVisible) {
        this.onSetCSDialogData({
          cSDialogVisible: !data.sSDialogVisible,
          cSDialogData: data.sSDialogData.certData
        });
      }
    },
    onSetCSDialogData (data) {
      this.cSDialogVisible = data.cSDialogVisible;
      this.cSDialogData = data.cSDialogData;
    },
    onSetSSDialogData (data) {
      this.sSDialogVisible = data.sSDialogVisible;
      this.sSDialogData = data.sSDialogData;
      if (data.sSDialogData && !data.sSDialogVisible) {
        this.onSetCSDialogData({
          cSDialogVisible: !data.sSDialogVisible,
          cSDialogData: data.sSDialogData.certData
        });
      }
    },

    //履约文件相关 882需求新增
    openLYDialog (rowData) {
      this.lYDialogVisible = true;
      this.rowData = rowData;
      this.setLYDialogData();
    },
    //展示履约文件弹窗
    async setLYDialogData () {
      let _this = this;
      let param = {
        uploadType: this.activeName,
        applyNo: this.rowData.applyNo || ""
      };
      let res = await ApiMethods.PerformanceController.getList(param);
      if (res.success) {
        this.lYDialogData = res.data;
      } else {
        _this.$message.error(res.description);
      }
    },
    // 获取附件后缀
    getEnclosureSuffix (item) {
      if (item.fileName) {
        let arr = item.fileName.split(".");
        return arr[arr.length - 1];
      }
      return "";
    },
    // 附件是否文档
    isDoc (item) {
      let str = this.getEnclosureSuffix(item).toLocaleUpperCase();
      // let arr = ['DOCX','DOC','PDF','XLS','XLSX']
      let arr = ["PDF"];
      if (arr.indexOf(str) > -1) {
        return true;
      }
      return false;
    },
    // 附件是否图片或视频
    isVideoOrImg (item) {
      let str = this.getEnclosureSuffix(item).toLocaleUpperCase();
      // let arr = ['DOCX','DOC','PDF','XLS','XLSX']
      let arr = ["PNG", "GIF", "JPG", "JPEG", "MP4", "WEBM", "OGG"];
      if (arr.indexOf(str) > -1) {
        return true;
      }
      return false;
    },
    // 预览履约文件图片或者视频
    previewVideOrImg (item) {
      this.enclosurePreviewNumItem = item;
      this.visibleShowEnclosure = true;
      // 刷新预览弹窗，更新
      this.isRefresh = false;
      this.$nextTick(() => {
        this.isRefresh = true;
      });
    },
    // 预览履约文件文档
    previewDoc (item) {
      this.enclosurePreviewNumItem = item;
      this.visibleShowEnclosureDoc = true;
    },

    //删除履约文件
    delLYFile (item) {
      this.$confirm("该操作删除后的文件将无法恢复，确认删除？", "系统提示", {
        showCancelButton: true,
        showCancelButton: true,
        type: "info"
      })
        .then(() => {
          ApiMethods.PerformanceController.del({
            performanceId: item.performanceId
          })
            .then(data => {
              if (data.success) {
                this.setLYDialogData();
              } else {
                _this.$message.error(data.description);
              }
            })
            .catch(err => {
              this.$message.error(
                err.description || "删除失败，请刷新后再试！"
              );
            });
        })
        .catch(() => { });
    },
    //下载履约文件
    downloadLYFile (item) {
      if (!item || item === "null" || item === "false")
        return "javascript:void(0)";
      if (item.fileName === "blob") {
        item.fileName = "attachment.png";
        item.fix = ".png";
      }
      return getFindFileDownload(item);
    },
    // 执行预览图片视频关闭后参数回传
    onSetViewFilesToImgDialogData (data) {
      this.visibleShowEnclosure = data.visibleShow;
      this.enclosurePreviewNumItem = data.obj;
    },
    // 执行预览PDF关闭后参数回传
    onSetViewFilesToDocDialogData (data) {
      this.visibleShowEnclosureDoc = data.visibleShow;
      this.enclosurePreviewNumItem = data.obj;
    },
    // 上传履约文件
    handleInputChange: function (e) {
      e = e.target;
      let param = { file: e.files[0] };
      if (!param.file) return;
      var frm = new FormData();
      if (+this.activeName == 1) {
        if (param.file.size > 30 * 1024 * 1024) {
          e.value = "";
          param = { file: "" };

          return this.$confirm(`上传的签章文件不能超过30M`, "系统提示", {
            showCancelButton: false,
            confirmButtonText: "确定",
            type: "warning"
          })
            .then(() => { })
            .catch(() => { });
        }
        frm.append("file", param.file);
        frm.append("fileName", e.files[0].name);
        frm.append("uploadType", this.activeName);
        frm.append("applyNo", this.rowData.applyNo);
        ApiMethods.PerformanceController.upload(frm)
          .then(res => {
            this.$refs.referenceUpload.value = null;
            if (res.success) {
              this.$message.success("上传成功");
              this.setLYDialogData();
            } else {
              this.$message.error(res.description);
            }
          })
          .catch(e => {
            this.$message.error(e.description);
          });
      } else {
        if (param.file.size > 500 * 1024 * 1024) {
          e.value = "";
          param = { file: "" };

          return this.$confirm(`上传的签章文件不能超过500M`, "系统提示", {
            showCancelButton: false,
            confirmButtonText: "确定",
            type: "warning"
          })
            .then(() => { })
            .catch(() => { });
        }
        let _this = this;
        let targetFileHash = "";
        const sha512 = sha512Crypto.create();
        _this.fileSliceDeal(
          e.files[0],
          1024 * 1024 * 2,
          function (fileSlice) {
            sha512.update(fileSlice);
          },
          function () {
            targetFileHash = sha512.hex();
            frm.append("hashValue", targetFileHash);
            frm.append("fileName", e.files[0].name);
            frm.append("uploadType", _this.activeName);
            frm.append("applyNo", _this.rowData.applyNo);
            ApiMethods.PerformanceController.upload(frm)
              .then(res => {
                _this.$refs.referenceUpload1.value = null;
                if (res.success) {
                  _this.$message.success("上传成功");
                  _this.setLYDialogData();
                } else {
                  _this.$message.error(res.description);
                }
              })
              .catch(e => {
                _this.$message.error(e.description);
              });
          }
        );
      }
    },
    //tab切花
    handleClick (tab) {
      this.activeName = tab.name;
      this.setLYDialogData();
    },
    //验证跳转
    validLYFile (item) {
      const url = "https://www.ebaoquan.org/query?type=2&bah=" + item.presId
      isInDingTalk ? location.href = url : window.open(url, "_blank");
      // window.open(
      //   "http://sandbox.ebaoquan.org/query?type=2&bah=" + item.presId,
      //   "_blank"
      // );
    },
    //哈希需要
    fileSliceDeal: function (file, sliceSize, dealFun, finishFun) {
      var startTime = new Date().getTime();
      var chunkSize = file.size;
      var chunks = 1;
      var blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice;
      if (blobSlice) {
        chunkSize = sliceSize;
        chunks = Math.ceil(file.size / chunkSize);
      }
      var currentChunk = 0;
      var fileReader = new FileReader();
      fileReader.onload = function (e) {
        dealFun(e.target.result, currentChunk, chunks);
        currentChunk++;
        if (currentChunk < chunks) {
          loadNext();
        } else {
          finishFun();
          //            console.log('finished');
          //            console.log(new Date().getTime() - startTime)
        }
      };
      fileReader.onerror = function () {
        console.warn("oops, something went wrong.");
      };
      function loadNext () {
        var start = currentChunk * chunkSize;
        var end =
          start + chunkSize >= file.size ? file.size : start + chunkSize;
        fileReader.readAsArrayBuffer(
          blobSlice ? blobSlice.call(file, start, end) : file
        );
      }
      loadNext();
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__header {
  /*padding: 0 !important;*/
  border-radius: 6px 6px 0 0;
  overflow: hidden;
}

/deep/ .el-dialog__title {
  padding: 10px;
}
/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #ffffff;
}
.node_header {
  height: 50px;
  line-height: 50px;
  text-align: center;
  background-color: #ed4031;

  background-size: 100%;
  font-size: 16px;
  color: #ffffff;
}
/deep/ .el-table__expand-icon {
  display: none !important;
}
.operate-box {
  /*  display: flex; */
  justify-content: flex-start;
  align-items: center;
}
.hover-win {
  padding: 5px;

  .icontag:hover {
    background: whitesmoke;
  }
}

.icontag {
  color: #ddd;
}

.textEllipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #290202;
  opacity: 0.65;
}
.bulkOperation {
  width: 85%;
  height: 50px;
  background: #f9f9f9;
  position: absolute;
  top: 99px;
  left: 140px;
  display: flex;
  align-items: center;
  color: rgba(41, 2, 2, 0.45);

  /deep/ .el-button {
    background: rgba(236, 28, 28, 1);
    color: #ffffff;
    margin-left: 10px;

    &:hover {
      opacity: 0.7;
    }
  }
}
.multiFile {
  position: absolute;
  font-size: 12px;
  top: 0px;
  left: -12px;
  width: 22px;
  height: 16px;
  line-height: 16px;
  background-color: #eb090a;
  color: #ffffff;
  text-align: center;
  border-radius: 4px;
  transform: scale(0.8);
  z-index: 2;
  &:after {
    content: "";
    position: absolute;
    bottom: -4px;
    right: 4px;
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-right: 5px solid #eb090a;
    z-index: 1;
  }
}
.operation span {
  display: inline-block;
  margin-right: 10px;
  cursor: pointer;
}

.query-label {
  font-weight: 600;
  white-space: nowrap;
}

.insurance-info .info-box {
  padding: 0 20px 20px 20px;

  p {
    margin-bottom: 10px;
  }

  .title {
    vertical-align: top;
    display: inline-block;
    text-align: right;
    width: 100px;
    margin-right: 10px;
  }

  .box {
    display: inline-block;
  }
}

.insurance-dialog .insurance-form {
  width: 80%;
  margin: 0 auto 40px auto;

  .btn {
    width: 220px;
  }
}

.file-name {
  display: inline-block;
  cursor: pointer;

  i {
    display: inline-block;
    width: 22px;
    height: 18px;
    position: absolute;
    top: 15px;
    left: -13px;
  }
}

.action {
  span {
    cursor: pointer;
  }
}

.sign-list {
  max-width: 1200px;
  margin: 0 auto;

  .color-success {
    cursor: pointer;
  }

  .pageation {
    padding: 30px 10px 20px 10px;
    border-top: 0;
    min-height: 85px;
  }

  .dialog-footer {
    padding-bottom: 20px;

    .btn {
      width: 30%;
    }
  }

  nav.nav-bar {
    width: 100%;
    margin-top: 20px;
    border: 1px dashed #d7d7d7;
    overflow: hidden;

    li.nav-item {
      margin-right: 14px;
      padding: 10px 15px;
      color: #666;
      border: none;
      background: #fff;
      cursor: pointer;
    }

    .nav-item.active {
      color: #ec1c1c;
    }

    ul.nav {
      width: 100%;
    }
  }
}

.tag-flag {
  display: inline-block;
  height: 18px;
  width: 19px;
  background-image: url(/images/icon/icon-flag.png);
  background-size: cover;
  background-repeat: no-repeat;
}

.tip-flag-1 {
  background-color: #faca32;
}

.tip-flag-2 {
  background-color: #71ac74;
}

.tip-flag-3 {
  background-color: #da4848;
}

.tip-flag-4 {
  background-color: #e5a196;
}

.tip-flag-5 {
  background-color: #615044;
}

.tip-flag-6 {
  background-color: #f79448;
}

.tip-flag-7 {
  background-color: #8181c1;
}

.tip-flag-8 {
  background-color: #895fa7;
}

.tip-flag-9 {
  background-color: #34699a;
}

.tip-flag-10 {
  background-color: #468a8c;
}

.flagActive {
  border: 1px solid red;
}

.ly-mask {
  .tips {
    color: rgb(115, 90, 90);
    font-size: 12px;
    text-align: left;
  }

  .box-wrap {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-left: -20px;
    margin-top: -15px;
    padding: 15px;
    &:last-child {
      /* margin-bottom: 130px; */
    }
    .temone {
      position: relative;
      margin: 15px 0 0 20px;
      width: 175px;
      text-align: center;
      border: 1px solid rgba(238, 238, 238, 1);
      border-radius: 4px;
      &.add {
        cursor: pointer;
        height: 140px;
        line-height: 140px;
        display: flex;
        justify-content: center;
        align-items: center;
        .file-ipt {
          width: inherit;
          height: inherit;
          position: absolute;
          opacity: 0;
        }
        &:hover {
          box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.28);
        }
      }
      &.temone-center {
        height: 140px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .t-box {
          width: 100%;
          height: 75%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          overflow: hidden;
          .y-img {
            margin-top: 0;
          }
        }
        .tpid {
          width: 100%;
          height: 25%;
          background: #eeeeee;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      &:hover {
        .t-box {
          .msk {
            width: 100%;
            height: 100%;
            opacity: 1;
          }
        }

        .has-hover {
          display: block;
        }
        .no-hover {
          display: none;
        }
      }
      .t-box {
        position: relative;
        height: 105px;
        overflow: hidden;

        .y-img {
          width: 46px;
          height: 54px;
          display: block;
          margin: 17px auto 7px auto;
        }
        p {
          font-size: 14px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          padding: 0 10px;
          width: 100%;
          font-family: Source Han Sans SC;
          color: rgba(41, 2, 2, 0.65);
          box-sizing: border-box;
        }
        .msk {
          transition: all ease 0.2s;
          position: absolute;
          left: 0;
          top: 0;
          width: 0;
          height: 0;
          background: rgba(0, 0, 0, 0.5);
          opacity: 0;
          padding: 8px 8px;
          box-sizing: border-box;
          .des {
            margin-top: 20px;
            font-size: 12px;
            text-align: left;
          }
          p {
            color: rgba(41, 2, 2, 0.65);
          }
          span {
            cursor: pointer;
            color: #ffffff;
            margin-left: 10px;
          }
        }
      }

      .b-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        a {
          width: 50%;
        }
      }
      .el-icon-plus {
        cursor: pointer;
        color: #c9bfbf;
        font-size: 80px;
      }
    }
  }
  .a-btn {
    cursor: pointer;
    display: flex;
    justify-content: space-evenly;
    width: 100%;
    height: 35px;
    line-height: 35px;
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: rgba(41, 2, 2, 1);
    text-decoration: none;
    border-radius: 0px 0px 4px 4px;
    background: rgba(239, 239, 239, 1);
    a {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      &:hover {
        color: rgba(236, 28, 28, 1);
      }
    }
    .has-hover {
      display: none;
    }
    .no-hover {
      display: block;
    }
  }
}

/deep/.ly-info .el-tabs__item.is-active {
  color: rgb(236, 28, 28);
}

/deep/.ly-info .el-tabs__active-bar {
  background-color: rgb(236, 28, 28);
}

/deep/.ly-info .el-tabs__item {
  color: rgb(158, 140, 140);
}
.footer {
  height: 50px;
  position: relative;
  .num {
    margin-left: 20px;
    font-size: 14px;
    color: rgb(140, 140, 140);
    label {
      color: #ec1c1c;
    }
  }
  .cancel-btn {
    position: absolute;
    right: 20px;
  }
}
.temone-box {
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  max-height: 45vh;
  overflow-y: scroll;
  img {
    width: 7vw;
    margin: 0.5vw;
    border: 1px solid transparent;
  }
  .active-chap {
    border: 1px solid #ec1c1c;
  }
  .temone {
    cursor: pointer;
  }
  p {
    font-size: 14px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 0 10px;
    width: 7vw;
    font-family: Source Han Sans SC;
    box-sizing: border-box;
    height: 35px;
    line-height: 35px;
    background: rgba(239, 239, 239, 1);
    color: rgba(41, 2, 2, 0.65);
  }

  .t-box {
    position: relative;
    width: 100%;
    height: 105px;
    display: flex;
    justify-content: center;
    align-items: center;
    // flex-direction: column;

    .y-img {
      width: 96px;
      height: auto;
      display: block;
      margin: 8px auto 7px auto;
    }
  }
}
/deep/.ly-info .el-dialog__body {
  height: 420px;
  overflow-y: auto;
}
/deep/.ly-info .el-dialog__footer {
  text-align: left;
}
</style>
<style lang="less">
.el-popper .popper__arrow::after {
  border-bottom-color: #f5f6f6 !important;
}
</style>



// WEBPACK FOOTER //
// pages/corp/signInfo/signListNew.vue